import api from './client';

export interface TeamMember {
  id: string;
  full_name: string;
  email: string;
  avatar_url?: string;
  role: 'lead' | 'member';
}

export interface Team {
  id: string;
  organization_id: string;
  name: string;
  description: string;
  color: string;
  member_count: number;
  members: TeamMember[];
  created_at: string;
  updated_at: string;
}

export const listTeams = async (): Promise<Team[]> => {
  const response = await api.get('/api/teams');
  return response.data.teams || [];
};

export const createTeam = async (data: {
  name: string;
  description: string;
  color: string;
}): Promise<Team> => {
  const response = await api.post('/api/teams', data);
  return response.data.team;
};

export const updateTeam = async (
  id: string,
  data: { name?: string; description?: string; color?: string }
): Promise<Team> => {
  const response = await api.patch(`/api/teams/${id}`, data);
  return response.data.team;
};

export const deleteTeam = async (id: string): Promise<void> => {
  await api.delete(`/api/teams/${id}`);
};

export const addTeamMember = async (
  teamId: string,
  userId: string,
  role: 'lead' | 'member' = 'member'
): Promise<TeamMember> => {
  const response = await api.post(`/api/teams/${teamId}/members`, { userId, role });
  return response.data.member;
};

export const removeTeamMember = async (teamId: string, userId: string): Promise<void> => {
  await api.delete(`/api/teams/${teamId}/members/${userId}`);
};

export const updateTeamMemberRole = async (
  teamId: string,
  userId: string,
  role: 'lead' | 'member'
): Promise<void> => {
  await api.patch(`/api/teams/${teamId}/members/${userId}`, { role });
};
